export default __webpack_public_path__ + "static/media/DOM-SEPT2026.1217f243.png";